/**
 * Builds a GitHub commit URL from a repository origin and commit hash.
 *
 * Accepts the GitHub origin forms that appear in eval `revision.origin`:
 * https, `ssh://git@github.com/…`, scp `git@github.com:…`, `git://…`, an
 * optional `git+` prefix, optional credentials, and an optional `.git` suffix.
 * Returns undefined when the origin is not a GitHub repository URL, so callers
 * can render the commit as plain text instead of a broken link.
 */
export const ghCommitUrl = (
  origin: string,
  commit: string
): string | undefined => {
  const match = origin.match(
    /(?:^|[@/])github\.com[/:]([^/]+)\/([^/]+?)(?:\.git)?\/?$/i
  );
  if (!match) {
    return undefined;
  }
  const [, owner, repo] = match;
  return `https://github.com/${owner}/${repo}/commit/${commit}`;
};
